module.exports = __webpack_public_path__ + "img/play.cf15ce00.svg";